/* src/app/features/prestacao-informacoes/acompanhamento-depr/acompanhamento-depr-cadastro/acompanhamento-depr-cadastro.component.scss */
.link-pointer {
  cursor: pointer;
}
.link-disabled {
  color: var(--bndes-prata) !important;
}
.text-sylver {
  color: darkgray;
  font-weight: bold;
}
/*# sourceMappingURL=acompanhamento-depr-cadastro.component.css.map */
